const INTERACTIVE_SELECTOR =
  'button, a, input, select, textarea, label, [role="button"], [role="checkbox"], [role="menuitem"], [contenteditable="true"], [role="dialog"]';

const eventTargetElement = (target: EventTarget | null): Element | null => {
  if (target instanceof Element) {
    return target;
  }
  return target instanceof Node ? target.parentElement : null;
};

const selectionTouchesTarget = (currentTarget: EventTarget, selection: Selection): boolean => {
  if (!(currentTarget instanceof Node)) {
    return false;
  }
  return Boolean(
    (selection.anchorNode && currentTarget.contains(selection.anchorNode)) ||
    (selection.focusNode && currentTarget.contains(selection.focusNode))
  );
};

export const shouldSkipRowNavigation = ({
  target,
  currentTarget,
  selection
}: {
  target: EventTarget | null;
  currentTarget: EventTarget;
  selection: Selection | null;
}): boolean => {
  const element = eventTargetElement(target);
  if (element && currentTarget instanceof Node) {
    // A dialog opened from a cell (a photo lightbox) is a React child of the row, so its clicks
    // bubble to the row although the portal puts it outside the row in the DOM.
    if (!currentTarget.contains(element)) {
      return true;
    }
    // Only a control inside the row counts: a table inside a sheet sits in its role="dialog".
    const interactive = element.closest(INTERACTIVE_SELECTOR);
    if (interactive && currentTarget.contains(interactive)) {
      return true;
    }
  }
  // Only suppress navigation when the user is selecting text inside this row,
  // not for a stale selection elsewhere in the document.
  return Boolean(
    selection && !selection.isCollapsed && selection.toString() && selectionTouchesTarget(currentTarget, selection)
  );
};
